import React from "react";
import AutoTyping from "react-auto-typing";
import { Dots } from "react-dot-patterns";

const HowItWorks = () => {
  return (
    <div className="manufacturing-working-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
          // evenColoumnShift={20}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
          // evenColoumnShift={20}
        />
      </div>
      <div className="section-title">
        <h1 className="title">How It Works</h1>
      </div>
      <div className="working-container">
        <div className="working-box">
          <div className="working-detail first">
            <div className="arrow"></div>
            <h4>Needs Analysis</h4>
            <p>
              We conduct an in-depth analysis of your production challenges.
            </p>
          </div>
        </div>
        <div className="working-box">
          <div className="working-detail second">
            <div className="arrow"></div>
            <h4>Customization</h4>
            <p>Our software is tailored to fit your manufacturing workflows.</p>
          </div>
        </div>
        <div className="working-box">
          <div className="working-detail third">
            <div className="arrow"></div>
            <h4>Implementation</h4>
            <p>
              Seamless deployment with integration into your existing systems.
            </p>
          </div>
        </div>
        <div className="working-box">
          <div className="working-detail forth">
            <div className="arrow"></div>
            <h4>Ongoing Support</h4>
            <p>We provide continuous monitoring, updates, and improvements.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
